var _templateObject = _taggedTemplateLiteralLoose(['\n  height: 110px;\n  margin-bottom: 0;\n'], ['\n  height: 110px;\n  margin-bottom: 0;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  border-top: 5px solid ', ';\n  background-color: ', ';\n  border-bottom: solid 1px ', ';\n  box-shadow: 1px 1px 2px ', ';\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  padding: 1.5rem 2rem;\n  z-index: 9999;\n'], ['\n  border-top: 5px solid ', ';\n  background-color: ', ';\n  border-bottom: solid 1px ', ';\n  box-shadow: 1px 1px 2px ', ';\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  padding: 1.5rem 2rem;\n  z-index: 9999;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  max-width: ', 'px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 auto;\n\n  .burger-menu-button.no-sidebar {\n    @media screen and (min-width: 1025px) {\n      display: none;\n    }\n  }\n'], ['\n  background-color: ', ';\n  max-width: ', 'px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 auto;\n\n  .burger-menu-button.no-sidebar {\n    @media screen and (min-width: 1025px) {\n      display: none;\n    }\n  }\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  background-color: ', ';\n  padding: 0.5rem 0;\n  text-align: center;\n  position: absolute;\n  bottom: -30px;\n  left: 0;\n  right: 0;\n\n  a {\n    color: ', ' !important;\n    border-bottom: dashed 1px ', ' !important;\n    font-weight: bold;\n\n    &:hover {\n      color: ', ' !important;\n      border-bottom: dashed 1px ', ' !important;\n    }\n  }\n\n  & * {\n    color: ', ' !important;\n  }\n'], ['\n  background-color: ', ';\n  padding: 0.5rem 0;\n  text-align: center;\n  position: absolute;\n  bottom: -30px;\n  left: 0;\n  right: 0;\n\n  a {\n    color: ', ' !important;\n    border-bottom: dashed 1px ', ' !important;\n    font-weight: bold;\n\n    &:hover {\n      color: ', ' !important;\n      border-bottom: dashed 1px ', ' !important;\n    }\n  }\n\n  & * {\n    color: ', ' !important;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { useState } from 'react';
import styled, { withTheme } from 'styled-components';
import Burger from '../Burger';
import Logo from '../Logo';
import HorizontalMenuItems, { Items } from '../HorizontalMenuItems';
import VerticalMenuItems from '../VerticalMenuItems';
import LoginPane from '../LoginPane';
import Constants from '../../../../themes/rml';
var Wrapper = styled.div(_templateObject);
var Container = styled.div(_templateObject2, Constants.colours.neutral.base, Constants.colours.neutral.lightest, Constants.colours.neutral.base, Constants.colours.neutral.base);
var Header = styled.header(_templateObject3, Constants.colours.neutral.lightest, Constants.ui.containerWidth);
var Ribbon = styled.div(_templateObject4, Constants.colours.primary.dark, Constants.colours.neutral.lightest, Constants.colours.neutral.lightest, Constants.colours.secondary.base, Constants.colours.secondary.base, Constants.colours.neutral.lightest);
/*
// Useful to keep in case the header needs to fix on scroll changing between absolute and fixed.

const getScrollPosition = () => {
  const scroll = document.body.scrollTop || document.documentElement.scrollTop;
  const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  return Math.ceil(scroll / height * 100);
}

function throttle(alwaysExecuteFn, throttledFn, wait) {
  var time = Date.now();
  return function() {
    alwaysExecuteFn();

    if ((time + wait - Date.now()) < 0) {
      throttledFn();
      time = Date.now();
    }
  }
}
*/

var showHamburger = function showHamburger(sidebar, buttons, pivotHorizontalButtons) {
  return sidebar || buttons && pivotHorizontalButtons;
};

var RML_Header = function RML_Header(props) {
  var adminDomain = props.adminDomain,
      buttons = props.buttons,
      groupDomain = props.groupDomain,
      _props$isLoggedIn = props.isLoggedIn,
      isLoggedIn = _props$isLoggedIn === undefined ? false : _props$isLoggedIn,
      login = props.login,
      logout = props.logout,
      _props$pivotHorizonta = props.pivotHorizontalButtons,
      pivotHorizontalButtons = _props$pivotHorizonta === undefined ? true : _props$pivotHorizonta,
      ribbon = props.ribbon,
      sidebar = props.sidebar,
      websiteDomain = props.websiteDomain;

  var _useState = useState(false),
      isMenuOpen = _useState[0],
      _toggleMenu = _useState[1];

  var _useState2 = useState(false),
      loginPaneOpen = _useState2[0],
      toggleLoginPane = _useState2[1];
  /*
    // Use this if scrolling effects needs to be enabled
    // It is required that you `import useState` and assign the scrollState var to the
    // className of the Container styled component.
    // <Container className={scrollState}>
     const [ scrollState, setScrollState ] = useState('default');
    useEffect(() => {
      const onScroll = throttle(
        () => {
          if (getScrollPosition() === 0) {
            setScrollState('default');
          }
        },
        () => {
          const newState = getScrollPosition() < 1 ? 'default' : 'stick';
          if (scrollState !== newState) {
            setScrollState(newState);
          }
        }, 500);
       window.addEventListener('scroll', onScroll);
       return () => {
        window.removeEventListener('scroll', onScroll);
      }
    }, []);
  */


  return React.createElement(Wrapper, null, React.createElement(Container, null, React.createElement(Header, null, React.createElement(Logo, props), React.createElement(HorizontalMenuItems, {
    buttons: buttons,
    isLoggedIn: isLoggedIn,
    login: login,
    logout: logout,
    groupDomain: groupDomain,
    websiteDomain: websiteDomain,
    onLogin: function onLogin() {
      _toggleMenu(false);

      toggleLoginPane(!loginPaneOpen);
    },
    burger: showHamburger(sidebar, buttons, pivotHorizontalButtons) && React.createElement('div', {
      className: 'burger-menu-button ' + (sidebar ? 'with-sidebar' : 'no-sidebar')
    }, React.createElement(Burger, {
      toggleMenu: function toggleMenu() {
        _toggleMenu(!isMenuOpen || loginPaneOpen);

        toggleLoginPane(false);
      },
      isMenuOpen: isMenuOpen && !loginPaneOpen
    }))
  })), React.createElement(LoginPane, {
    adminDomain: adminDomain,
    groupDomain: groupDomain,
    display: loginPaneOpen,
    toggle: function toggle() {
      toggleLoginPane(false);
    }
  }), ribbon && React.createElement(Ribbon, null, ribbon), React.createElement(VerticalMenuItems, {
    toggle: function toggle() {
      _toggleMenu(!isMenuOpen && !loginPaneOpen);
    },
    expanded: isMenuOpen && !loginPaneOpen,
    menuItems: sidebar,
    pivotHorizontalButtons: pivotHorizontalButtons,
    buttons: buttons,
    groupDomain: groupDomain,
    websiteDomain: websiteDomain
  })));
};

export default withTheme(RML_Header);